<ui-card-table
  [showDrawer]="showDrawer"
  [hasBackdrop]="true"
  (openedDrawerChange)="openedDrawerChange($event)"
>
  <h4 card-title>Versiones</h4>
  <div card-search-action>
    <commonui-search (searchText)="onSearch($event)"></commonui-search>
  </div>

  <div class="d-flex justify-content-between" card-actions>
    <button
      class="button-outline-primary mb-1 controls-button"
      mat-flat-button
      color="accent"
      (click)="openAddItemDialog()"
    >
      Adicionar
    </button>
  </div>

  <div card-sm-actions>
    <button mat-icon-button color="accent" (click)="openAddItemDialog()">
      <mat-icon class="d-flex" svgIcon="plus"></mat-icon>
    </button>
  </div>

  <div
    card-drawer-content
    class="row align-items-start justify-content-start w-100 gx-0"
    commonui-loader
    [appLoader]="(dataSource.loading$ | async) ?? false"
  >
    <div class="col-12">
      <mat-table [dataSource]="paginatedItems">
        <ng-container matColumnDef="versionName">
          <mat-header-cell *matHeaderCellDef>
            Nombre de versión
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.versionName }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="versionCode">
          <mat-header-cell *matHeaderCellDef>
            Código de versión
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.versionCode }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="required">
          <mat-header-cell *matHeaderCellDef>Requerido</mat-header-cell>
          <mat-cell *matCellDef="let item">
            @if (item.required) {
              Actualización requerida
            } @else {
              Actualizacón no requerida
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="updatedAt">
          <mat-header-cell *matHeaderCellDef
            >Fecha de actualización</mat-header-cell
          >
          <mat-cell *matCellDef="let item">
            {{ item.updatedAt | date: 'dd/MM/yyyy - HH:mm' }}
          </mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <!-- PC ACTIONS LIST -->
        <ng-container matColumnDef="actions">
          <mat-header-cell
            class="action-col-centered justify-content-center"
            *matHeaderCellDef
          >
            <span class="d-none d-md-block">Acciones</span>
          </mat-header-cell>
          <mat-cell class="action-col-centered" *matCellDef="let item">
            <div class="d-none d-lg-flex">
              <ng-container>
                <button
                  mat-icon-button
                  matTooltip="Detalles"
                  (click)="detail(item)"
                >
                  <mat-icon svgIcon="eye"></mat-icon>
                </button>
              </ng-container>

              <ng-container>
                <button
                  mat-icon-button
                  matTooltip="Editar"
                  (click)="openEditDriverDialog(item)"
                >
                  <mat-icon svgIcon="pencil" class="me-1"></mat-icon>
                </button>
              </ng-container>

              <ng-container>
                <button
                  mat-icon-button
                  matTooltip="Eliminar"
                  (click)="openDeleteDialog(item)"
                >
                  <mat-icon
                    svgIcon="trash-can"
                    class="action_element"
                  ></mat-icon>
                </button>
              </ng-container>
            </div>

            <!-- MOBILE ACTIONS MENU-->
            <div class="d-block d-lg-none">
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="Acciones"
              >
                <mat-icon
                  svgIcon="expand_vert"
                  class="action_element"
                ></mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <ng-container>
                  <button mat-menu-item (click)="detail(item)">
                    <mat-icon svgIcon="eye"></mat-icon>
                    <span>Detalles</span>
                  </button>
                </ng-container>

                <ng-container>
                  <button mat-menu-item (click)="openEditDriverDialog(item)">
                    <mat-icon svgIcon="pencil"></mat-icon>
                    <span>Editar</span>
                  </button>
                </ng-container>

                <ng-container>
                  <button mat-menu-item (click)="openDeleteDialog(item)">
                    <mat-icon svgIcon="trash-can"></mat-icon>
                    <span>Eliminar</span>
                  </button>
                </ng-container>
              </mat-menu>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        <div class="w-100 text-center pt-3 text-muted" *matNoDataRow>
          Sin resultados para mostrar
        </div>
      </mat-table>
    </div>
  </div>
  <mat-paginator
    card-drawer-paginator
    [length]="paginatedItems.data.length"
    [pageSize]="dataSource.PAGE_SIZE"
    [pageSizeOptions]="dataSource.PAGE_SIZE_OPTIONS"
    #paginator
  >
  </mat-paginator>
  <mat-tab-group animationDuration="200" card-drawer>
    <mat-tab label="Detalles" bodyClass="tab-body">
      <t-llevo-version-control-detail-tab></t-llevo-version-control-detail-tab>
    </mat-tab>
  </mat-tab-group>
</ui-card-table>
